import { Resource } from "../resource";

export class City extends Resource {
	name: string | null | undefined
}